import { Component, Input, OnDestroy, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MeetingsService } from '@app/services/meetings/meetings.service';
import { Subscription } from 'rxjs';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-addmeeting',
  templateUrl: './addmeeting.component.html',
  styleUrls: ['./addmeeting.component.css']
})
export class AddmeetingComponent implements OnDestroy, OnInit {
  @Input() institution;
  @Output() closeAddMeeting: EventEmitter<any> = new EventEmitter();

  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  addmeetingform;
  

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private meetingService: MeetingsService,
    private snackbarService: SnackbarService,
    public confirmationService: ConfirmationService) { }

    ngOnInit(): void {
      this.addmeetingform = this.fb.group({
        institutionId: ['', ''],
        meetingTypeId: ['', Validators.required],
        meetingDate: ['', Validators.required],
        issue: ['', [Validators.required, Validators.maxLength(30)]],
        comment: ['', ''],
        action: ['', '']
      });
    }
    
  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  addMeeting() {
    const meeting = {
      institutionId: this.institution.id,
      meetingTypeId: this.addmeetingform.get('meetingTypeId').value,
      meetingDate: this.addmeetingform.get('meetingDate').value,
      issue: this.addmeetingform.get('issue').value,
      comment: this.addmeetingform.get('comment').value,
      action: 'add'
    };

    this.meetingService.addMeeting(meeting).subscribe(data => {
      if (data.status === 'ok') {
        this.snackbarService.openSnackBar('Mötet har lagts till.', null);
        this.closeAddMeeting.emit();
      }
    });
  }

  close() {
    if (this.addmeetingform.dirty) {
       this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avbryta utan att spara ändringarna?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.closeAddMeeting.emit();
      },
      reject: () => {
      }
    });
    } else {
      this.closeAddMeeting.emit();
    }
  }

}
